import { useEffect } from "react";
import { useTheme } from "next-themes";
import { readThemeFromUserSettings } from "@/lib/user-settings-storage";

/**
 * Синхронизирует next-themes с темой из geopulse:user-settings при загрузке приложения,
 * чтобы значение из настроек имело приоритет над устаревшим ключом localStorage theme.
 */
export function UserSettingsThemeSync() {
  const { setTheme } = useTheme();

  useEffect(() => {
    setTheme(readThemeFromUserSettings());
  }, [setTheme]);

  return null;
}
